module.exports = __webpack_public_path__ + "img/blue_020.4489dbd8.png";